// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__DHAaj","head":"ProcedureTableInfo_head__2WwQ1"};